export interface ProfiloUpdate {
  avatarUrl?: string;
  password?: string;
  email?: string;
}
